module.exports = __webpack_public_path__ + "static/media/moveStart.ddb20330.gif";